import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'passentry-plan-token';

export const usePlanToken = () => {
  const location = useLocation();
  const getInitialPlanToken = () => {
    try {
      const search =
        typeof window !== 'undefined' ? window.location.search : '';
      const queryParams = new URLSearchParams(search);
      const queryPlanToken = queryParams.get('planToken');
      const storedPlanToken =
        typeof window !== 'undefined'
          ? sessionStorage.getItem(STORAGE_KEY)
          : null;
      if (queryPlanToken) {
        sessionStorage.setItem(STORAGE_KEY, queryPlanToken);
        return queryPlanToken;
      }
      return storedPlanToken || null;
    } catch {
      return null;
    }
  };
  const [planToken, setPlanToken] = useState(getInitialPlanToken);
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryPlanToken = queryParams.get('planToken');

    if (queryPlanToken) {
      sessionStorage.setItem(STORAGE_KEY, queryPlanToken);
      setPlanToken(queryPlanToken);
    }
  }, [location.search]);

  const clearPlanToken = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    setPlanToken(null);

    // Remove planToken from URL if it exists
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.has('planToken')) {
      queryParams.delete('planToken');
      const newSearch = queryParams.toString();
      const newPath = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
      navigate(newPath, { replace: true });
    }
  };

  return {
    planToken,
    clearPlanToken,
    STORAGE_KEY,
  };
};
